import { render, staticRenderFns } from "./LateFees.vue?vue&type=template&id=135631a8&scoped=true"
import script from "./LateFees.vue?vue&type=script&lang=js"
export * from "./LateFees.vue?vue&type=script&lang=js"
import style0 from "./LateFees.vue?vue&type=style&index=0&id=135631a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135631a8",
  null
  
)

export default component.exports